// German texts - the source of the TextKey type; en.ts must have exactly the same keys.

export const de = {
  "app.name": "FitCalendar",
  "app.tagline": "Deine Fahrten im Kalender",
  "app.privacy": "Deine Dateien verlassen den Browser nicht.",

  "action.import": "FIT importieren",
  "action.importShort": "Import",
  "action.today": "Heute",
  "action.prevMonth": "Voriger Monat",
  "action.nextMonth": "Nächster Monat",
  "action.prevRide": "Vorige Fahrt",
  "action.nextRide": "Nächste Fahrt",
  "action.back": "Zurück",
  "action.close": "Schließen",
  "action.delete": "Fahrt löschen",
  "action.deleteConfirm": "Löschen",
  "action.cancel": "Abbrechen",
  "action.download": "Original-FIT herunterladen",
  "action.undo": "Rückgängig",
  "action.retry": "Erneut versuchen",
  "action.rename": "Umbenennen",
  "action.more": "Mehr",
  "action.zoomBack": "Zoom zurück",
  "action.resetZoom": "Ganze Fahrt",
  "action.showRow": "zeigen",
  "action.resetRow": "Zurücksetzen",
  "action.open": "Öffnen",

  "lang.label": "Sprache",
  "theme.label": "Darstellung",
  "theme.auto": "Automatisch",
  "theme.light": "Hell",
  "theme.dark": "Dunkel",

  "weekday.short.0": "Mo",
  "weekday.short.1": "Di",
  "weekday.short.2": "Mi",
  "weekday.short.3": "Do",
  "weekday.short.4": "Fr",
  "weekday.short.5": "Sa",
  "weekday.short.6": "So",
  "calendar.week": "Woche",
  "calendar.weekShort": "KW {n}",
  "calendar.rides": "{n} Fahrten",
  "calendar.ride": "1 Fahrt",
  "calendar.more": "+{n} weitere",
  "calendar.noRidesWeek": "Keine Fahrten",
  "calendar.monthTotal": "Monat gesamt",
  "calendar.noRidesMonth": "Keine Fahrten im {month}",
  "calendar.lastRide": "Letzte Fahrt: {date}",
  "calendar.nextRide": "Nächste Fahrt: {date}",
  "calendar.longest": "Längste Fahrt",
  "calendar.perRide": "Ø pro Fahrt",
  "calendar.vsPrev": "zum Vormonat",
  "calendar.pickMonth": "Monat wählen",
  "calendar.emptyTitle": "Noch keine Fahrten",
  "calendar.emptyText": "Ziehe FIT-Dateien hierher oder wähle sie aus.",
  "calendar.loadError": "Die gespeicherten Fahrten konnten nicht geladen werden.",

  "totals.count": "Fahrten",
  "totals.distance": "Distanz",
  "totals.movingTime": "Zeit",
  "totals.ascent": "Höhenmeter",

  "import.title": "Import {done} / {total}",
  "import.parsing": "wird gelesen …",
  "import.added": "importiert",
  "import.duplicate": "schon vorhanden",
  "import.error.not_fit": "kein FIT-Format",
  "import.error.truncated": "Datei abgeschnitten",
  "import.error.crc": "Prüfsumme fehlerhaft",
  "import.error.not_activity": "keine Aktivitätsdatei",
  "import.error.no_records": "keine Datensätze",
  "import.error.unknown": "konnte nicht gelesen werden",
  "import.summary": "{added} neu · {duplicates} doppelt · {errors} Fehler",

  "sport.ride": "Radfahrt",
  "sport.run": "Lauf",
  "sport.walk": "Spaziergang",
  "sport.hike": "Wanderung",
  "sport.swim": "Schwimmen",
  "sport.other": "Aktivität",
  "sport.indoor": "Indoor / virtuell",

  "channel.altitude": "Höhe",
  "channel.speed": "Geschwindigkeit",
  "channel.heartRate": "Herzfrequenz",
  "channel.power": "Leistung",
  "channel.cadence": "Trittfrequenz",
  "channel.gradient": "Steigung",
  "channel.temperature": "Temperatur",

  "unit.m": "m",
  "unit.km": "km",
  "unit.kmh": "km/h",
  "unit.bpm": "bpm",
  "unit.w": "W",
  "unit.rpm": "U/min",
  "unit.percent": "%",
  "unit.celsius": "°C",
  "unit.kcal": "kcal",

  "stat.distance": "Distanz",
  "stat.movingTime": "Bewegungszeit",
  "stat.elapsedTime": "Gesamtzeit {v}",
  "stat.ascent": "Anstieg",
  "stat.descent": "Abstieg {v}",
  "stat.speed": "Ø Geschwindigkeit",
  "stat.heartRate": "Ø Herzfrequenz",
  "stat.power": "Ø Leistung",
  "stat.cadence": "Ø Trittfrequenz",
  "stat.gradient": "Ø Steigung",
  "stat.temperature": "Ø Temperatur",
  "stat.calories": "Kalorien",
  "stat.max": "max {v}",
  "stat.whole": "Gesamt {v}",

  "detail.noGps": "Keine GPS-Daten - diese Fahrt hat keine Strecke.",
  "detail.notFound": "Fahrt nicht gefunden.",
  "detail.loadError": "Die Daten der Fahrt konnten nicht geladen werden.",
  "detail.reparse": "Neu einlesen",
  "detail.deleteQuestion": "„{title}“ löschen?",
  "detail.deleteText": "Die Fahrt wird aus diesem Browser entfernt.",
  "detail.deleted": "Fahrt gelöscht",
  "detail.axis": "x-Achse",
  "detail.axisDistance": "Distanz",
  "detail.axisTime": "Zeit",
  "detail.smoothing": "Glättung",
  "detail.smoothingOff": "Aus",
  "detail.channels": "Kurven",
  "detail.hint": "Ziehen: Bereich zoomen · Klick: Punkt merken · Doppelklick: ganze Fahrt",
  "detail.colouring": "Farbe",
  "detail.colourPlain": "Einfarbig",
  "detail.follow": "Karte folgt dem Punkt",
  "detail.laps": "Runden",
  "detail.climbs": "Anstiege",
  "detail.noClimbs": "Keine Anstiege über 20 Höhenmeter.",
  "detail.col.number": "#",
  "detail.col.start": "Start",
  "detail.col.length": "Länge",
  "detail.col.time": "Zeit",
  "detail.col.speed": "Ø km/h",
  "detail.col.ascent": "Hm",
  "detail.col.gradient": "Ø %",
  "detail.col.maxGradient": "max %",
  "detail.col.heartRate": "Ø HF",
  "detail.col.power": "Ø W",
  "detail.device": "Gerät: {device}",
  "detail.chartsLabel": "Profile - Pfeiltasten bewegen den Punkt",
  "detail.overview": "Übersicht der ganzen Fahrt",
  "detail.start": "Start",
  "detail.finish": "Ziel",

  "action.save": "Speichern",
  "channel.balance": "L/R-Balance",
  "detail.noLaps": "Diese Fahrt hat keine Runden.",
  "detail.noSplits": "Zu kurz für Splits.",
  "detail.splitLength": "Split-Länge",
  "detail.splits": "Splits",
  "detail.statistics": "Statistik",
  "group.cadence": "Trittfrequenz",
  "group.distanceTime": "Distanz und Zeit",
  "group.elevation": "Höhe",
  "group.heart": "Herzfrequenz",
  "group.pedals": "Pedale",
  "group.power": "Leistung",
  "group.speed": "Geschwindigkeit",
  "group.temperature": "Temperatur",
  "group.training": "Training und Ernährung",
  "nav.calendar": "Kalender",
  "nav.profile": "Profil",
  "power.curve": "Leistungskurve",
  "power.duration": "Dauer",
  "profile.current": "Aktuelle Werte",
  "profile.entryHint": "Nur ausgefüllte Felder werden gespeichert; leere behalten ihren bisherigen Wert. Eine Fahrt nutzt die Werte, die an ihrem Tag galten - Fahrten vor dem ersten Eintrag nutzen den ersten.",
  "profile.ftp": "FTP",
  "profile.history": "Verlauf",
  "profile.intro": "Deine Werte für Zonen, Intensität (IF), Trainingsbelastung (TSS) und W/kg - nur was du hier selbst einträgst, nichts aus den FIT-Dateien. Sie bleiben in diesem Browser.",
  "profile.lthr": "Schwellen-HF",
  "profile.maxHr": "Max. HF",
  "profile.noHistory": "Noch keine Einträge.",
  "profile.notSet": "nicht gesetzt",
  "profile.now": "jetzt {v}",
  "profile.removeEntry": "Eintrag löschen",
  "profile.restHr": "Ruhe-HF",
  "profile.saveEntry": "Eintrag speichern",
  "profile.title": "Athletenprofil",
  "profile.today": "heute",
  "profile.validFrom": "Gültig ab",
  "profile.weight": "Gewicht",
  "profile.zoneFrom": "ab",
  "profile.zonesDefault": "Standard",
  "profile.zonesOfFtp": "Untergrenzen in % der FTP.",
  "profile.zonesOfMaxHr": "Untergrenzen in % der max. HF.",
  "profile.zonesOrder": "Die Zonen müssen aufsteigend sein.",
  "stat.aerobicTe": "Aerober Trainingseffekt",
  "stat.anaerobicTe": "Anaerober Trainingseffekt",
  "stat.balance": "L/R-Balance",
  "stat.best20": "Beste 20 min",
  "stat.best20Line": "20 min {v}",
  "stat.descentLabel": "Abstieg",
  "stat.elapsed": "Gesamtzeit",
  "stat.ftp": "FTP",
  "stat.heartPctMax": "Ø % der max. HF",
  "stat.ifLine": "IF {v}",
  "stat.intensity": "Intensity Factor (IF)",
  "stat.maxAltitude": "Max. Höhe",
  "stat.maxCadence": "Max. Trittfrequenz",
  "stat.maxGradient": "Max. Steigung",
  "stat.maxHeartRate": "Max. Herzfrequenz",
  "stat.maxPower": "Max. Leistung",
  "stat.maxSpeed": "Max. Geschwindigkeit",
  "stat.maxTemperature": "Max. Temperatur",
  "stat.minAltitude": "Min. Höhe",
  "stat.minTemperature": "Min. Temperatur",
  "stat.movingSpeed": "Ø Geschwindigkeit",
  "stat.normalizedPower": "Normalized Power (NP)",
  "stat.npPerKilo": "NP pro kg",
  "stat.overallSpeed": "Ø inkl. Pausen",
  "stat.powerPerKilo": "Ø W/kg",
  "stat.smoothLeft": "Pedalgleichmäßigkeit L",
  "stat.smoothRight": "Pedalgleichmäßigkeit R",
  "stat.torqueLeft": "Drehmomenteffektivität L",
  "stat.torqueRight": "Drehmomenteffektivität R",
  "stat.tss": "Training Stress Score (TSS)",
  "stat.work": "Arbeit",
  "totals.stress": "TSS",
  "unit.kg": "kg",
  "unit.percentLeft": "% links",
  "zones.askFtp": "Für Leistungszonen, IF und TSS brauchen wir deine FTP.",
  "zones.askMaxHr": "Für die Pulszonen brauchen wir deine maximale Herzfrequenz.",
  "zones.ftpIs": "FTP {v} W",
  "zones.maxHrIs": "Max. HF {v} bpm",
  "zones.heart": "Herzfrequenz-Zonen",
  "zones.power": "Leistungszonen",
  "zones.toProfile": "Alle Werte im Profil",
  "zones.h1": "Erholung",
  "zones.h2": "Grundlage",
  "zones.h3": "Tempo",
  "zones.h4": "Schwelle",
  "zones.h5": "Maximum",
  "zones.p1": "Aktive Erholung",
  "zones.p2": "Grundlage",
  "zones.p3": "Tempo",
  "zones.p4": "Schwelle",
  "zones.p5": "VO2max",
  "zones.p6": "Anaerob",
  "zones.p7": "Neuromuskulär",
  "tray.drop": "FIT-Dateien oder Ordner hierher ziehen",
  "tray.or": "oder",
  "tray.chooseFiles": "Dateien wählen",
  "tray.chooseFolder": "Ordner wählen",
  "tray.hint": "Mehrere Dateien: im Auswahlfenster mit Strg oder Shift markieren. Ein Ordner bringt alle .fit-Dateien darin mit, auch aus Unterordnern.",
  "tray.count": "{n} Dateien · {size}",
  "tray.clear": "Alle entfernen",
  "tray.remove": "Entfernen",
  "tray.skipped": "{n} Dateien ohne .fit wurden nicht aufgenommen.",
  "tray.importOne": "1 Datei importieren",
  "tray.importMany": "{n} Dateien importieren",
  "tray.dropHint": "Loslassen - die Dateien kommen ins Ablagefeld",
  "export.button": "FIT exportieren",
  "export.title": "FIT-Dateien als ZIP exportieren",
  "export.from": "Alle Fahrten ab",
  "export.count": "{n} Fahrten ab diesem Tag",
  "export.countOne": "1 Fahrt ab diesem Tag",
  "export.download": "ZIP herunterladen",
  "export.packing": "wird gepackt …",
  "export.done": "{n} Dateien exportiert",
  "export.failed": "Der Export ist fehlgeschlagen.",
  "power.ofRide": "ganze Fahrt",
  "power.ofStretch": "Abschnitt",
} as const;

export type TextKey = keyof typeof de;
